var RYOKO = {
  name: "RYOKO",
  defaultCommandIndex: 1,
  commands: [
     {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [19,0,4,65,2,217,0,72,2,200,3,118,12,228,5,80,2,0,0,43,221,0],
     },
     {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,219,0,72,2,204,3,129,12,221,5,67,2,0,0,43,221,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,216,0,128,12,213,5,76,2,207,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,69,2,218,0,142,12,208,5,78,2,209,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,220,0,127,12,208,5,77,2,206,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,70,2,214,0,125,12,214,5,75,2,210,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,215,0,122,12,216,5,75,2,208,3,87,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,221,0,127,12,211,5,78,2,211,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,218,0,129,12,212,5,77,2,212,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,217,0,129,12,209,5,77,2,222,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,217,0,122,12,184,5,98,2,209,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,217,0,130,12,214,5,75,2,210,3,86,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,218,0,123,12,231,5,67,2,202,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,218,0,150,12,202,5,83,2,207,3,91,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,220,0,140,12,222,5,70,2,217,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,216,0,153,12,205,5,80,2,211,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,218,0,121,12,229,5,66,2,211,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,128,12,215,5,73,2,209,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,216,0,129,12,215,5,75,2,209,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,217,0,152,12,231,5,68,2,211,3,73,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [19,0,4,65,2,217,0,125,12,230,5,67,2,207,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,218,0,151,12,212,5,76,2,214,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,218,0,122,12,216,5,76,2,208,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,217,0,125,12,209,5,75,2,214,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,218,0,119,12,217,5,75,2,214,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,214,0,125,12,229,5,69,2,176,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,121,12,215,5,76,2,209,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,220,0,153,12,201,5,83,2,214,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,214,0,129,12,229,5,66,2,215,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,122,12,217,5,72,2,221,3,70,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,218,0,127,12,212,5,77,2,212,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,218,0,122,12,231,5,69,2,207,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,217,0,123,12,214,5,75,2,213,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,217,0,129,12,209,5,77,2,220,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,218,0,122,12,206,5,78,2,208,3,87,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,217,0,128,12,214,5,73,2,214,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,218,0,125,12,201,5,80,2,211,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,216,0,143,12,214,5,77,2,208,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,218,0,124,12,203,5,82,2,217,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,215,0,125,12,214,5,77,2,216,3,87,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,215,0,118,12,204,5,79,2,195,3,77,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,216,0,130,12,201,5,80,2,211,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,216,0,125,12,204,5,80,2,214,3,88,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,216,0,125,12,204,5,80,2,213,3,88,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,218,0,127,12,217,5,72,2,214,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,210,0,130,12,228,5,69,2,210,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [19,0,4,70,2,209,0,123,12,229,5,73,2,205,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,216,0,126,12,230,5,71,2,196,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,198,0,135,12,206,5,91,2,201,3,88,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,218,0,130,12,228,5,73,2,205,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,213,0,127,12,229,5,72,2,207,3,87,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,217,0,122,12,229,5,68,2,207,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,123,12,229,5,68,2,217,3,70,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,213,0,131,12,229,5,69,2,205,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,219,0,127,12,208,5,79,2,207,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,213,0,129,12,229,5,73,2,200,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,217,0,132,12,230,5,67,2,213,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,216,0,124,12,228,5,69,2,207,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,215,0,129,12,214,5,76,2,214,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,65,2,214,0,128,12,230,5,68,2,212,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,65,2,216,0,116,12,224,5,70,2,207,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,214,0,131,12,230,5,72,2,209,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,129,12,231,5,67,2,211,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,215,0,128,12,228,5,70,2,205,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,215,0,149,12,228,5,72,2,208,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,214,0,125,12,216,5,74,2,203,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,214,0,126,12,230,5,70,2,208,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,213,0,132,12,231,5,72,2,202,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,214,0,142,12,231,5,68,2,210,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,217,0,121,12,224,5,70,2,213,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,216,0,149,12,231,5,74,2,198,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,218,0,125,12,230,5,69,2,206,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,214,0,124,12,229,5,70,2,204,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,216,0,122,12,230,5,72,2,207,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,214,0,130,12,222,5,75,2,209,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,70,2,209,0,122,12,231,5,68,2,210,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,212,0,122,12,223,5,75,2,203,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,70,2,210,0,148,12,220,5,80,2,208,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,212,0,123,12,231,5,69,2,216,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,213,0,124,12,228,5,72,2,204,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,216,0,128,12,230,5,74,2,211,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,217,0,119,12,232,5,67,2,206,3,72,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,215,0,124,12,232,5,67,2,211,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [19,0,4,65,2,213,0,127,12,221,5,74,2,200,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,217,0,122,12,230,5,68,2,209,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,218,0,142,12,215,5,73,2,220,3,77,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,213,0,129,12,218,5,74,2,209,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,216,0,154,12,232,5,67,2,207,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,215,0,130,12,230,5,69,2,210,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [19,0,4,65,2,219,0,124,12,229,5,73,2,206,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,159,12,227,5,74,2,210,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,217,0,124,12,229,5,68,2,207,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,217,0,126,12,229,5,68,2,213,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,216,0,127,12,231,5,70,2,209,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,215,0,128,12,231,5,69,2,205,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,213,0,128,12,212,5,81,2,208,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,218,0,127,12,230,5,67,2,211,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,216,0,68,2,208,3,123,12,229,5,74,2,0,0,43,221,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [19,0,4,65,2,219,0,76,2,216,3,144,12,210,5,73,2,0,0,43,221,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,215,0,118,12,231,5,68,2,210,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [19,0,4,65,2,219,0,154,12,229,5,66,2,209,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,216,0,119,12,218,5,75,2,210,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,212,0,155,12,228,5,69,2,207,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,213,0,127,12,229,5,72,2,206,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,212,0,150,12,229,5,69,2,213,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,214,0,131,12,230,5,71,2,215,3,72,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,216,0,129,12,229,5,67,2,222,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,213,0,123,12,230,5,68,2,209,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,216,0,124,12,231,5,71,2,204,3,71,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,201,0,158,12,210,5,88,2,198,3,74,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,214,0,153,12,230,5,71,2,209,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,210,0,145,12,230,5,72,2,204,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,213,0,123,12,230,5,71,2,203,3,70,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,216,0,74,2,213,3,130,12,216,5,66,2,0,0,43,221,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,65,2,216,0,145,12,230,5,69,2,198,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,217,0,128,12,230,5,68,2,213,3,74,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,126,12,232,5,68,2,207,3,75,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,131,12,226,5,68,2,206,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,217,0,125,12,210,5,75,2,215,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,215,0,128,12,212,5,78,2,215,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,214,0,148,12,229,5,70,2,212,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,217,0,128,12,230,5,71,2,205,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,65,2,216,0,127,12,229,5,67,2,213,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,128,12,216,5,76,2,214,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,214,0,122,12,216,5,76,2,206,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,212,0,128,12,229,5,72,2,207,3,74,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,216,0,129,12,217,5,76,2,213,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,212,0,120,12,229,5,68,2,208,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,214,0,129,12,229,5,68,2,212,3,79,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,221,0,122,12,230,5,71,2,209,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,217,0,122,12,214,5,76,2,210,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,216,0,128,12,230,5,70,2,206,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,219,0,155,12,229,5,73,2,197,3,73,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,215,0,120,12,230,5,68,2,205,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,217,0,117,12,222,5,74,2,214,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,214,0,131,12,231,5,68,2,207,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,205,0,133,12,227,5,82,2,200,3,63,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,216,0,120,12,231,5,67,2,213,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,68,2,216,0,120,12,232,5,68,2,211,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,215,0,145,12,229,5,76,2,204,3,64,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,218,0,120,12,213,5,78,2,213,3,70,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,216,0,70,2,200,3,145,12,231,5,73,2,0,0,43,221,0],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,217,0,132,12,231,5,68,2,210,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,216,0,140,12,225,5,73,2,207,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,217,0,127,12,207,5,79,2,206,3,72,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,217,0,131,12,202,5,81,2,211,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,218,0,128,12,219,5,74,2,206,3,75,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,66,2,216,0,123,12,213,5,75,2,216,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [19,0,4,67,2,215,0,125,12,206,5,82,2,209,3,74,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,216,0,124,12,231,5,68,2,214,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [19,0,4,65,2,216,0,119,12,221,5,75,2,206,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,218,0,140,12,229,5,69,2,215,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,122,12,231,5,67,2,214,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,217,0,126,12,229,5,68,2,212,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,215,0,130,12,229,5,72,2,206,3,86,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,217,0,125,12,229,5,68,2,210,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,204,0,136,12,204,5,93,2,195,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,214,0,122,12,229,5,70,2,211,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [19,0,4,68,2,213,0,128,12,230,5,75,2,207,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,219,0,124,12,210,5,77,2,216,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,216,0,126,12,230,5,69,2,203,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [19,0,4,66,2,215,0,126,12,230,5,72,2,204,3,65,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,215,0,154,12,231,5,69,2,210,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,215,0,156,12,229,5,71,2,215,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [19,0,4,67,2,215,0,121,12,231,5,69,2,207,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,221,0,157,12,229,5,71,2,207,3,70,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,214,0,151,12,229,5,69,2,206,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,216,0,124,12,230,5,70,2,201,3,73,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,213,0,148,12,230,5,72,2,207,3,67,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,216,0,115,12,231,5,70,2,208,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [19,0,4,68,2,215,0,123,12,229,5,71,2,209,3,85,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,219,0,122,12,217,5,74,2,213,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [19,0,4,69,2,211,0,127,12,227,5,70,2,206,3,71,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [19,0,4,67,2,201,0,142,12,189,5,100,2,195,3,83,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,216,0,134,12,227,5,78,2,202,3,65,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,202,0,132,12,200,5,97,2,197,3,80,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [19,0,4,72,2,199,0,146,12,195,5,97,2,200,3,86,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,220,0,122,12,216,5,83,2,203,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [19,0,4,70,2,195,0,143,12,198,5,90,2,202,3,78,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,206,0,135,12,208,5,89,2,197,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [19,0,4,66,2,217,0,146,12,230,5,74,2,205,3,82,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_HIGH",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_16",
      command: [18,0,4,66,2,217,0,144,12,230,5,69,2,207,3,83,2,0,0,73,231,0],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,214,0,133,12,228,5,77,2,206,3,65,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,145,12,230,5,68,2,207,3,73,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,216,0,128,12,209,5,80,2,204,3,81,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,217,0,142,12,215,5,75,2,213,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,214,0,129,12,216,5,78,2,199,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,213,0,121,12,230,5,69,2,205,3,64,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,214,0,129,12,231,5,69,2,216,3,68,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,218,0,129,12,229,5,71,2,206,3,84,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,68,2,211,0,122,12,230,5,72,2,205,3,71,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,215,0,122,12,218,5,73,2,214,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,217,0,129,12,214,5,79,2,206,3,69,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,67,2,214,0,130,12,230,5,71,2,204,3,76,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,213,0,129,12,224,5,76,2,211,3,74,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,215,0,130,12,213,5,78,2,204,3,66,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,69,2,211,0,126,12,228,5,76,2,202,3,72,2,0,0,73,231,32],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [19,0,4,66,2,219,0,128,12,229,5,67,2,211,3,66,2,0,0,73,231,32],
    },
    ]
};

export default RYOKO
